function initCarouselReviews() {
  const carouselElement = document.querySelector('.home-reviews__carousel');
  
  if (carouselElement && typeof Swiper !== 'undefined') {
    const config = JSON.parse(carouselElement.getAttribute('data-carousel-config'));
    
    const swiper = new Swiper('.home-reviews__carousel', {
      slidesPerView: config.slidesPerView,
      spaceBetween: 20,
      loop: config.loop,
      autoplay: config.autoplay ? {
        delay: config.autoplayDelay,
        disableOnInteraction: false,
      } : false,
      navigation: config.showNavigation ? {
        nextEl: '.home-reviews__nav--next',
        prevEl: '.home-reviews__nav--prev',
      } : false,
      pagination: config.showPagination ? {
        el: '.home-reviews__pagination',
        clickable: true,
      } : false,
      breakpoints: {
        320: {
          slidesPerView: config.slidesPerViewMobile,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: config.slidesPerView,
          spaceBetween: 20,
        },
      },
    });
    
  } else if (carouselElement && typeof Swiper === 'undefined') {
    setTimeout(initCarouselReviews, 100);
  } else if (!carouselElement) {
  }
}

window.addEventListener('load', function() {
  setTimeout(initCarouselReviews, 50);
});

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(initCarouselReviews, 50);
});